module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/pathways-hero-03-e1d8ab5821c5bc365cd128cfc0549720.svg";